import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  employeesList: "",
  feedbackList: "",
  podcastAll: "",
  featureList: "",
  featureUserList: "",
  allSurveyList: "",
  magazineList: "",
  ticketList: "",
  ideaboardList: "",
  hallofFameList: "",
  announcementList: "",
  sosList: "",
  virtualEventList: "",
  faq: "",
  error: null,
};

const companyAdminPanelSlice = createSlice({
  name: "companyAdminPanel",
  initialState: initialState,
  reducers: {
    getEmployees(state, payload) {
      state.employeesList = payload.payload.response;
    },
    getFeedbacks(state, payload) {
      state.feedbackList = payload.payload.response;
    },
    getPodcastAll(state, payload) {
      state.podcastAll = payload.payload.response;
    },
    getFeatureList(state, payload) {
      state.featureList = payload.payload.response;
    },
    getUserFeatureList(state, payload) {
      state.featureUserList = payload.payload.response;
    },
    getAllSurvey(state, payload) {
      state.allSurveyList = payload.payload.response;
    },
    getMagazine(state, payload) {
      state.magazineList = payload.payload.response;
    },
    getTicketList(state, payload) {
      state.ticketList = payload.payload.response;
    },
    getIdeaboard(state, payload) {
      state.ideaboardList = payload.payload.response;
    },
    gethallofFame(state, payload) {
      state.hallofFameList = payload.payload.response;
    },
    getAnnouncement(state, payload) {
      state.announcementList = payload.payload.response;
    },
    getSOS(state, payload) {
      state.sosList = payload.payload.response;
    },
    getVirtualEvent(state, payload) {
      state.virtualEventList = payload.payload.response;
    },
    getFaq(state, payload) {
      state.faq = payload.payload.response;
    },
    alert(state, action) {
      state.error = action.payload;
    },
  },
});

export default companyAdminPanelSlice.reducer;
export const companyAdminPanelActions = companyAdminPanelSlice.actions;
